<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h5 class="border-line text-center" md="auto">{{title}}</h5>
        </b-col>
      </b-row>
    </b-container>
     
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    title: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.footer{
  font-size: 10px;
}
.title-txt{
  font-size: 16px;
}
.border-line{
  display: table;
  white-space: nowrap;
  &:before, &:after {
    border-top: 1px solid #CCC;
    content: '';
    display: table-cell;
    position: relative;
    top: 0.7em;
    width: 45%;
  }
  &:before { right: 1.5%; }
  &:after { left: 1.5%; }
}
</style>
